import InsuredTable from 'components/features/insured-table';
import HomeLayout from 'layouts/home-layout';

function InsuredRecords() {
  return (
    <HomeLayout title="Insured Records">
      <InsuredTable />
    </HomeLayout>
  );
}

export default InsuredRecords;
